import React, { useEffect, useState } from "react";
import TablePagination from "@mui/material/TablePagination";

const Pagination = ({ data = [], setData = () => {},tab,all }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // Paginated data
    if (Array.isArray(data) && data.length > 0) {
      const paginatedData = data.slice(
        newPage * rowsPerPage,
        newPage * rowsPerPage + rowsPerPage
      );
     
      setData(paginatedData);
    }
  };
  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const firstPage=page;
      // setPage(firstPage)
      const paginatedData = data.slice(
        firstPage * rowsPerPage,
        firstPage * rowsPerPage + rowsPerPage
      );
      console.log("🐛","🐶")

    
      setData(paginatedData);
    }
  }, [tab,all]);

  const handleChangeRowsPerPage = (event) => {
    console.log("⭐",event)
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TablePagination
      component="div"
      count={data.length}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
};

export default Pagination;
